/* globals jQuery */

import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';

import 'materialize-css/js/velocity.min';
import 'materialize-css/js/global';
import 'materialize-css/js/modal';

/**
 * Renders a modal in the format needed by materialize and does the initialization and teardown
 * automatically.
 */
class Modal extends Component {

    render() {
        const {className, title, children, footer, fixedFooter} = this.props;

        return (
            <div className={classNames('modal', className, {'modal-fixed-footer': fixedFooter})} ref={this.initModal}>
                <div className="modal-content">
                    {title && <h4>{title}</h4>}
                    {children}
                </div>
                <div className="modal-footer">
                    {footer}
                </div>
            </div>
        );
    }

    initModal = node => {
        const {dismissible, opacity, onDismiss} = this.props;

        this.modal = jQuery(node).modal({
            dismissible: dismissible || Boolean(onDismiss),
            complete: onDismiss || (() => {}),
            opacity,
        });

        this.modal.modal('open');
    };

    componentWillUnmount() {
        this.modal.modal('close');
    }
}


Modal.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
    footer: PropTypes.node,
    fixedFooter: PropTypes.bool,
    dismissible: PropTypes.bool,
    onDismiss: PropTypes.func,
    opacity: PropTypes.number,
};

Modal.defaultProps = {
    className: '',
    children: null,
    footer: null,
    fixedFooter: false,
    title: '',
    dismissible: false,
    onDismiss: null,
    opacity: 0.7,
};

export default Modal;



// WEBPACK FOOTER //
// ./scripts/components/Modal.js